import React from "react";
import AddComplaint from "../components/AddComplaint";

const GuestComplaint = () => {
  return (
    <div style={{ padding: "20px", minHeight: "100vh" }}>
      {/* ✅ Always pass "guest" for guest users */}
      <AddComplaint usernameProp="guest" />
    </div>
  );
};

export default GuestComplaint;
